import { render } from "./SwdStubForText.vue?vue&type=template&id=3f197771"
import script from "./SwdStubForText.vue?vue&type=script&lang=js"
export * from "./SwdStubForText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__